import { useCompanyGroupRepository } from "@/shared/contexts/repository-context";
import { usePagination } from "@/shared/hooks";
import { useHasGlobalPermission } from "@/shared/hooks/use-has-permission";
import { getGetCompanyGroupListPaginatedQueryKey } from "@/spz-api/company-groups/company-groups";
import { useGetMeSuspense } from "@/spz-api/user/user";
import { GlobalPermission } from "@spz/shared-domain";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useCreateOrUpdateCompanyGroupDialog } from "../dialogs/use-create-or-update-company-group-dialog";
import { useCompanyGroupsColumns } from "../hooks/use-company-groups-columns";

export const selectCompanyGroupsViewModel = () => {
  const { data: me } = useGetMeSuspense();
  const companyGroupRepository = useCompanyGroupRepository();

  const hasCompanyGroupsManagementPermission = useHasGlobalPermission(
    GlobalPermission.CompanyGroupsManage,
    me,
  );
  const columns = useCompanyGroupsColumns();

  const {
    currentPage,
    pageSize,
    paginationParams,
    handlePageChange,
    handlePageSizeChange,
  } = usePagination();
  const [searchQuery, setSearchQuery] = useState("");

  const queryParams = {
    page: paginationParams.page,
    pageSize: paginationParams.pageSize,
    search: searchQuery,
  };

  const {
    data: companyGroupsResponse = { data: [], total: 0, pageCount: 0 },
    isLoading,
  } = useQuery({
    queryKey: getGetCompanyGroupListPaginatedQueryKey(queryParams),
    queryFn: () => companyGroupRepository.getCompanyGroups(queryParams),
  });
  const createCompanyGroupDialog = useCreateOrUpdateCompanyGroupDialog();

  return {
    columns,
    companyGroups: {
      data: companyGroupsResponse.data,
      total: companyGroupsResponse.total,
    },
    isLoading,
    currentPage,
    pageSize,
    totalPages: companyGroupsResponse.pageCount,
    handlePageChange,
    handlePageSizeChange,
    setSearchQuery,
    createCompanyGroupDialog,
    hasCompanyGroupsManagementPermission,
  };
};
